module.exports = __webpack_public_path__ + "static/img/logo.074af98a.png";